import Image from "next/legacy/image";
import React from "react";
import { BASE_URL } from "../../utils/FetchData"


export default function AmenityMobile({index, amenity, phaseColor, commercialServices,businessProject,active }) {
	return (
		<div className={`amenity
		${commercialServices ? "commercialServices-section" : ""}
		${businessProject ? "businessProject" : ""}
		${active==index ? "active" : ""}
		`}>
			<div className="icon-container">
				<Image
					src={BASE_URL + amenity?.Icon?.data?.attributes?.url}
					layout="fill"
					objectFit="contain"
					alt="icon"
				/>
			</div>
			<div className="amenity-info">
				<h4 className="title">{amenity?.Text}</h4>
				<p className="desc">{amenity?.Description}</p>
			</div>
			<div className="back-layer"
				style={{ background: phaseColor ? phaseColor : "#292c33" }}
			></div>
			<div className="one"></div>
			<div className="one two"></div>
			<div className="one three"></div>
			<div className="one four"></div>
		</div>
	);
}
